import L from 'leaflet';

export const ICON = {
  END: 'end',
  START: 'start'
};

export const HEATMAP_OPTIONS = {
  weight: 1
};

export const HEATMAP_GRID_SIZE = 0.000027; // ~3m × 3m grid
export const HEATMAP_DEFAULT_OPACITY = 0.6;
export const LAYER_NAME = {
  FARMS: 'Farms',
  GEOFENCES: 'Pastures',
  GRAZING: 'Grazing',
  LIVESTOCK: 'Livestock',
  SITES: 'Sites'
};

export const GOOGLE_LAYER = {
  HYBRID: 'hybrid',
  TERRAIN: 'terrain'
};

export const TYPE = {
  FARM: 'farm',
  GEOFENCE: 'geofence',
  SITE: 'site'
};

export const DEFAULT_LINE_COLOR = '#ff0000';
export const DEFAULT_SHAPE_COLOR = '#3388ff';
export const EDIT_CONTROL_POSITION = 'topleft';
export const EDIT_CONTROL_DRAW_OPTIONS = {
  circlemarker: false,
  marker: false,
  point: false,
  polyline: false,
  rectangle: false
};
export const FULLSCREEN_CONTROL_POSITION = 'topright';
export const LAYERS_CONTROL_POSITION = 'bottomright';

export const FILL_OPACITY = {
  DEFAULT: 0.2,
  SELECTED: 0.4
};

export const LINE_WEIGHT = 2;

export const SHAPE_OPTIONS = {
  fillOpacity: FILL_OPACITY.DEFAULT,
  weight: LINE_WEIGHT
};

export const ZOOM = 10;
export const ZOOM_MAX = 20;

export const circleOptions = {
  color: '#ffffff',
  fillColor: '#000000',
  fillOpacity: 0,
  opacity: 0,
  radius: 1,
  weight: 0.5
};

export const customizeButtonLabels = () => {
  L.drawLocal.edit.toolbar.actions.save.text = 'Finish';
  L.drawLocal.edit.handlers.edit.tooltip.text = '';
  L.drawLocal.edit.handlers.edit.tooltip.subtext = `<span class="map-tooltip">Click <b>Finish</b> to save changes!</span>`;
};
